export function protocol (v: string): boolean {
  return (/^http(s)?:\/\//).test(String(v || ""))
}
